export default __webpack_public_path__ + "static/media/payment_two_icon.6e4ae449.svg";